"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionalResponse = exports.unwrapResponse = exports.assertNever = exports.mapValues = void 0;
function mapValues(obj, mapping) {
    return Object.keys(obj).reduce((acc, key) => {
        acc[key] = mapping(obj[key], key);
        return acc;
    }, {});
}
exports.mapValues = mapValues;
function assertNever(x) {
    throw new Error("Unexpected object: " + x);
}
exports.assertNever = assertNever;
const unwrapResponse = (response) => {
    if (response.type === "success") {
        return response.value;
    }
    throw response.error;
};
exports.unwrapResponse = unwrapResponse;
const optionalResponse = (response) => {
    if (response.type === "success") {
        return response.value;
    }
    return undefined;
};
exports.optionalResponse = optionalResponse;
